export const isEmpty = (value: unknown): boolean => {
  if (value === undefined || value === null) {
    return true
  }
  if (typeof value === 'number') {
    return value === 0
  }
  if (typeof value === 'boolean') {
    return value === false
  }
  if (typeof value === 'string') {
    return value === ''
  }
  if (Array.isArray(value)) {
    return value.length === 0
  }
  if (value instanceof Date) {
    return value.getTime() === 0
  }
  if (typeof value === 'object') {
    return Object.keys(value as Record<string, unknown>).length === 0
  }
  return false
}

export const isFieldsNotEmpty = (value: Record<string, unknown>) => {
  return Object.keys(value).reduce((acc, key) => {
    if (!isEmpty(value[key])) {
      return true
    }
    return acc
  }, false)
}

export const isObjectValueEmpty = (obj: object): boolean => {
  if (!obj) return true
  let isObjectEmpty = true
  Object.values(obj).forEach((val) => {
    if (typeof val === 'object') {
      isObjectEmpty = isObjectValueEmpty(val)
    }
    if (!isEmpty(val)) {
      isObjectEmpty = false
    }
  })
  return isObjectEmpty
}
